import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Button from '@material-ui/core/Button';
import WarningIcon from '@material-ui/icons/Warning';
import classNames from 'classnames';

import Linkify from '../../../components/Linkify/Linkify';
import messages from './messages';
import revisionMessages from '../../ManageBooking/components/RevisionDialog/messages';
import styles from './styles';

const getRevisionMessage = (revision) => {
    if (revision?.code === '685' && revision?.reason?.includes('delayed by overcrowding')) {
        return 'Delay';
    }
    return 'Cancel';
};
const getStatusMessage = (revision) => {
    if (revision?.status === 'DELAYED') {
        return 'Delayed';
    }
    return 'Cancelled';
};
const getMessage = (revision) => revisionMessages[`lblRevision${revision?.code === '685' ? getRevisionMessage(revision) : ''}${revision?.code}`];

const ServiceAlerts = ({
    classes,
    onClose,
    open,
    serviceAlerts,
    revisions,
    originStation,
    destinationStation,
    departTime,
    arriveTime,
}) => (
    <Dialog open={open} onClose={onClose}>
        <DialogContent>
            {serviceAlerts && (
                <div key="serviceAlertsSection" className={classNames('col-12', classes.alertRow)}>
                    <pre className={classes.alertHeading}>
                        <FormattedMessage {...revisionMessages.lblServiceAlerts} />
                    </pre>
                    {serviceAlerts && serviceAlerts.map((serviceAlert) => (
                        <>
                            <WarningIcon className={classes.icon} />
                            <div className={classes.content}>
                                <div className={classes.summary}>{serviceAlert.Summary}</div>
                                <div className={classes.description}>
                                    <Linkify>{serviceAlert.Description}</Linkify>
                                </div>
                            </div>
                        </>
                    ))}
                </div>
            )}
            {revisions && (
                <div key="revisionsSection" className={classNames('col-12', classes.alertRow)}>
                    <pre className={classes.alertHeading}><FormattedMessage {...revisionMessages.lblRevisions} /></pre>
                    {revisions && revisions.map((revision) => (
                        <>
                            <div className={classes.warning}>
                                <WarningIcon className={classes.icon} />
                                <strong><FormattedMessage {...revisionMessages[`lbl${getStatusMessage(revision)}`]} /></strong>
                            </div>
                            <p>
                                {getMessage(revision)
                                    ? (
                                        <>
                                            {`${revision?.code} : `}
                                            <FormattedMessage {...getMessage(revision)} />
                                        </>
                                    )
                                    : revision?.reason}
                            </p>
                            {revision?.revisedOriginTravelPoint || revision?.revisedDepartureDateTime
                                ? (
                                    <p>
                                        <div><FormattedMessage {...revisionMessages.lblOriginModifications} /></div>
                                        <div>
                                            <FormattedMessage {...revisionMessages.lblOriginalScheduledDepart} />
                                            {` ${originStation}, ${departTime}`}
                                        </div>
                                        <div>
                                            <FormattedMessage {...revisionMessages.lblNowDepart} />
                                            {` ${revision?.revisedOriginTravelPoint || originStation}, ${revision?.revisedDepartureDateTime}`}
                                        </div>
                                    </p>
                                )
                                : (
                                    <p>
                                        <div><FormattedMessage {...revisionMessages.lblOriginNoModifications} /></div>
                                        <div>
                                            <FormattedMessage {...revisionMessages.lblDepart} />
                                            {` ${originStation}, ${departTime}`}
                                        </div>
                                    </p>
                                )}
                            {revision?.revisedDestinationTravelPoint || revision?.revisedArrivalDateTime
                                ? (
                                    <p>
                                        <div><FormattedMessage {...revisionMessages.lblDestinationModifications} /></div>
                                        <div>
                                            <FormattedMessage {...revisionMessages.lblOriginalArrive} />
                                            {` ${destinationStation}, ${arriveTime}`}
                                        </div>
                                        <div>
                                            <FormattedMessage {...revisionMessages.lblNowArriving} />
                                            {` ${revision?.revisedDestinationTravelPoint || destinationStation}, ${revision?.revisedArrivalDateTime}`}
                                        </div>
                                    </p>
                                )
                                : (
                                    <p>
                                        <div><FormattedMessage {...revisionMessages.lblDestinationNoModifications} /></div>
                                        <div>
                                            {`Scheduled to arrive  ${destinationStation}, ${arriveTime}`}
                                        </div>
                                    </p>
                                )}
                        </>
                    ))}
                </div>
            )}
        </DialogContent>
        <DialogActions>
            <Button
                onClick={onClose}
                variant="contained"
                color="primary"
            >
                <FormattedMessage {...messages.lblClose} />
            </Button>
        </DialogActions>
    </Dialog>
);

ServiceAlerts.propTypes = {
    classes: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    serviceAlerts: PropTypes.array,
    revisions: PropTypes.array,
    originStation: PropTypes.string,
    destinationStation: PropTypes.string,
    departTime: PropTypes.string,
    arriveTime: PropTypes.string,
};

export { ServiceAlerts as ServiceAlertsAlias };

export default withStyles(styles)(ServiceAlerts);
